(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brazur-catalogue-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('brazur-grid-switch')) {
    customElements.define('brazur-grid-switch', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        let columns = '2';
        try { columns = sessionStorage.getItem('brazur-mobile-columns') === '1' ? '1' : '2'; } catch { /* Use the default when storage is unavailable. */ }
        this.setColumns(columns);
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-grid-toggle]');
          if (!button || !this.contains(button)) return;
          const columns = button.getAttribute('aria-pressed') === 'true' ? '2' : '1';
          this.setColumns(columns);
          try { sessionStorage.setItem('brazur-mobile-columns', columns); } catch { /* Switching remains available without storage. */ }
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
      setColumns(columns) {
        const grid = this.closest('.shopify-section')?.querySelector('.product-grid');
        if (!grid || !['1', '2'].includes(columns)) return;
        grid.dataset.bzMobileColumns = columns;
        const button = this.querySelector('[data-grid-toggle]');
        button.setAttribute('aria-pressed', String(columns === '1'));
        const label = this.querySelector(columns === '1' ? '[data-double-label]' : '[data-single-label]').textContent;
        button.title = label;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
